import api from "../api";

function logar(usuario, observacao) {
  usuario = usuario || {};
  return new Promise((resolve, reject) => {
    return api
      .post("/auth/login", {
        email: usuario.email,
        senha: usuario.senha,
        observacao
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
function logout() {
  return new Promise((resolve, reject) => {
    return api
      .post("/auth/logout", {})
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default {
  logar,
  logout
};
